import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MemberService } from '../../shared/services/member.service';

@Component({
  selector: 'def-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  readonly gaCategory: string = 'Personal Side Navbar';
  currentUrl: string;

  constructor(
    private router: Router,
    private memberService: MemberService,
  ) {
    this.setUrls();
    router.events.subscribe(() => {
      this.setUrls();
    });
  }

  logout() {
    this.memberService.userLogout();
  }

  private setUrls() {
    this.currentUrl = this.router.url.split('/').pop();
  }

}
